export default "__VITE_ASSET__zsRAbtxr__"